module.exports = __webpack_public_path__ + "static/media/img-empty.a573731c.png";